var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlogSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12117_27525)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 11.667H12.25",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12117_27525)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.55208 2.11268C9.7843 1.88046 10.0993 1.75 10.4277 1.75C10.7561 1.75 11.071 1.88046 11.3033 2.11268C11.5355 2.3449 11.6659 2.65985 11.6659 2.98826C11.6659 3.31667 11.5355 3.63163 11.3033 3.86385L4.29742 10.8703C4.15864 11.009 3.9871 11.1106 3.79867 11.1654L2.12333 11.6543C2.07314 11.6689 2.01993 11.6698 1.96928 11.6568C1.91863 11.6438 1.8724 11.6175 1.83543 11.5805C1.79846 11.5435 1.7721 11.4973 1.75913 11.4466C1.74615 11.396 1.74703 11.3428 1.76167 11.2926L2.2505 9.61726C2.30546 9.42904 2.40698 9.25771 2.54567 9.1191L9.55208 2.11268Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_12117_27525)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.75 2.91699L10.5 4.66699",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12117_27525",
  x: 6.5,
  y: 11.167,
  width: 7.25,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27525"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12117_27525",
  x: 1.25,
  y: 1.25,
  width: 11.9141,
  height: 11.916,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27525"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_12117_27525",
  x: 8.25,
  y: 2.41699,
  width: 3.75,
  height: 3.75,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27525"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlogSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";